import { Navigate, Link } from "react-router-dom";
import { ShieldCheck, Lock, Trash2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/context/ThemeContext";
import { useAuth, loginWithGoogle } from "@/context/AuthContext";

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden>
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export default function Login() {
  const { user, loading } = useAuth();
  if (!loading && user) return <Navigate to="/app" replace />;
  return (
    <div className="relative min-h-screen overflow-hidden px-5" data-testid="login-page">
      <div className="glow left-1/4 top-0 h-96 w-96 bg-blue-400/25" />
      <div className="glow bottom-0 right-10 h-80 w-80 bg-violet-400/25" />
      <div className="relative mx-auto flex max-w-6xl items-center justify-between py-6">
        <Logo />
        <ThemeToggle />
      </div>
      <div className="relative mx-auto mt-10 max-w-md sm:mt-20">
        <div className="glass rounded-3xl p-8 shadow-[0_30px_80px_-40px_hsl(var(--primary)/0.5)] sm:p-10">
          <h1 className="text-3xl font-extrabold tracking-tight">Bienvenue</h1>
          <p className="mt-2 text-sm text-muted-foreground">Connecte-toi ou crée ton compte en un clic pour retrouver tes cours.</p>
          <button
            data-testid="google-login-button"
            onClick={loginWithGoogle}
            className="mt-8 flex w-full items-center justify-center gap-3 rounded-full border bg-card px-5 py-3.5 text-sm font-semibold transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-primary/50"
          >
            <GoogleIcon /> Continuer avec Google
          </button>
          <ul className="mt-8 space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-2.5"><ShieldCheck className="h-4 w-4 shrink-0 text-primary" /> Tes cours restent privés, rien n'est publié.</li>
            <li className="flex gap-2.5"><Lock className="h-4 w-4 shrink-0 text-primary" /> Communications chiffrées, audio supprimé après transcription.</li>
            <li className="flex gap-2.5"><Trash2 className="h-4 w-4 shrink-0 text-primary" /> Tu peux supprimer ton compte et tes données à tout moment.</li>
          </ul>
          <p className="mt-8 text-xs text-muted-foreground">
            En continuant, tu acceptes nos <Link to="/confidentialite" className="underline hover:text-foreground">conditions et notre politique de confidentialité</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
